import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author @muhammedburakak
 */

const PaidCODReports = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'ID', filterType: FilterType.number, width: 50, show: false },
			{
				Header: 'startDate',
				accessor: 'startDate',
				filterType: FilterType.date,
				width: 110,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'endDate',
				accessor: 'endDate',
				filterType: FilterType.date,
				width: 110,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'totalAmount',
				accessor: 'totalAmount',
				filterType: FilterType.number,
				renderCell: ListComponents.CURRENCY,
				width: 70,
				showOnMobile: true
			},
			{
				Header: 'totalOrder',
				accessor: 'totalOrder',
				filterType: FilterType.number,
				width: 70
			},
			{
				Header: 'status',
				accessor: 'status',
				renderCell: ListComponents.STATUS,
				filterType: FilterType.string,
				width: 100,
				showOnMobile: true
			}
		],
		[]
	);

	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);
	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="paidCODReports"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.SHIPMENT_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList
				id={DYNAMICLISTS.PAID_COD_REPORTS}
				defaultSort={defaultSort}
				columns={columns}
				fetchUrl={REPORT.LIST.GET_PAID_COD_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="paidCODReports"
			/>
		</div>
	);
};

export default PaidCODReports;
